import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { TruncatePipe } from './pipes/truncate.pipe';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { TransformDatePipe } from './pipes/transform-date.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { ConvertTo24HourFormatPipe } from './pipes/convert-to-24-hour-format.pipe';
import { CommaSeparatedPipe } from './pipes/comma-separated.pipe';
import { CapitaliseNamesPipe } from './pipes/capitalise-names.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [TruncatePipe, CustomDatePipe, TransformDatePipe, FilterPipe, ConvertTo24HourFormatPipe, CommaSeparatedPipe, CapitaliseNamesPipe],
  exports: [TruncatePipe, CustomDatePipe, TransformDatePipe, FilterPipe, ConvertTo24HourFormatPipe, CommaSeparatedPipe, CapitaliseNamesPipe],
  providers: [DatePipe, TitleCasePipe],
})
export class SharedUtilsPipesModule {}
